module.exports = __webpack_public_path__ + "static/media/KE.fc27ffd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KE.svg
// module id = 286
// module chunks = 0